import { Client, Communicator } from '../../../concepts/objects';
import { ActiveObject, resolve } from '../../Container';
import { AlertDefinition, AlertManager } from './AlertManager';

export class AlertHub extends ActiveObject {

    @resolve(AlertManager) private alerts: AlertManager;
    @resolve(Communicator) private comms: Communicator;

    public start(): void {
        this.burden(
            this.comms.recv('alert', this.doRecvAlert)
        );
    }

    public invoke(alertDef: AlertDefinition): void {
        this.alerts.invoke(alertDef);
    }

    public send(alertDef: AlertDefinition): void {
        this.comms.send('alert', alertDef);
    }

    public sendAndInvoke(alertDef: AlertDefinition): void {
        this.send(alertDef);
        this.invoke(alertDef);
    }

    private doRecvAlert = (client: Client, data: any) => {
        this.invoke(data);
    };
}
